module.exports = __webpack_public_path__ + "img/telephone.7d5ad21f.svg";